/**
 * Create store system routing-bgp
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // config
    bgpConfig: `${smApiPrefix}/bgp/config`,
    // status
    bgpStatus: `${smApiPrefix}/bgp/config/status`,
    // status-neighbor
    bgpNeighborStatus: `${smApiPrefix}/bgp/config/status-neighbor`,
    // advance
    bgpAdvance: `${smApiPrefix}/bgp/config/advance`,
    // network list
    bgpNetworks: `${smApiPrefix}/bgp/config/networks`,
    // neighbors(routerList)
    bgpNeighbors: `${smApiPrefix}/bgp/config/neighbors`,
    // apply
    bgpApply: `${smApiPrefix}/bgp/config/apply`,
    // cancel
    bgpCancel: `${smApiPrefix}/bgp/config/cancel`
  },
  // copyData for editing.
  selectedItem: {},
  // bgp config
  bgpConfig: {
    enable: 0, //       enable required (one of 0, 1)
    as: 1, //           AS(integer - default: 1 - minimum: 1 - maximum: 65534)
    router_id: '0.0.0.0' //  Router ID required (string) (IPv4 Address)
  },
  bgpConfigClone: {
    enable: 0,
    as: 1,
    router_id: '0.0.0.0'
  },
  // bgp status
  bgpStatus: {
    status: ''
  },
  // bgp neighbor
  bgpNeighborStatus: {
    status: ''
  },
  // bgp advacne
  bgpAdvacne: {
    tcp_port: 179,
    external_distance: 20,
    internal_distance: 200,
    distance_local: 200,
    redist_static_enable: 0,
    redist_rip_enable: 0,
    redist_ospf_enable: 0
  },
  bgpNetwork: {
    id: 0,
    network_addr: null, //  네트워크 IP 주소
    network_mask: 0 //      네트워크 IP mask
  },
  bgpNetworkList: [],
  bgpNeighbor: {
    id: 0,
    router_addr: null, //     인접 라우터 IP 주소
    remote_as: 1, //          Remote AS  (integer - minimum: 1 - maximum: 65534)
    port: 179, //             port  (integer - default: 179 - minimum: 1 - maximum: 65535)
    default_orig_enable: 0 // Default Originate(OFF: 0, ON: 1)
  },
  bgpNeighborList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp config
  resetBgpConfig (state) {
    state.bgpConfig.enable = 0
    state.bgpConfig.as = 1
    state.bgpConfig.router_id = '0.0.0.0'
  },
  setBgpConfig (state, item) {
    state.bgpConfig.enable = item.enable
    state.bgpConfig.as = item.as
    state.bgpConfig.router_id = item.router_id
    // clone
    state.bgpConfigClone.enable = _.cloneDeep(item.enable)
    state.bgpConfigClone.as = _.cloneDeep(item.as)
    state.bgpConfigClone.router_id = _.cloneDeep(item.router_id)
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp status
  resetBgpStatus (state) {
    state.bgpStatus.status = ''
  },
  setBgpStatus (state, item) {
    state.bgpStatus.status = item.status
  },
  resetBgpNeighborStatus (state) {
    state.bgpNeighborStatus.status = ''
  },
  setBgpNeighborStatus (state, item) {
    state.bgpNeighborStatus.status = item.status
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp advance
  resetBgpAdvance (state) {
    state.bgpAdvacne.tcp_port = 179
    state.bgpAdvacne.external_distance = 20
    state.bgpAdvacne.internal_distance = 200
    state.bgpAdvacne.distance_local = 200
    state.bgpAdvacne.redist_static_enable = 0
    state.bgpAdvacne.redist_rip_enable = 0
    state.bgpAdvacne.redist_ospf_enable = 0
  },
  setBgpAdvance (state, item) {
    state.bgpAdvacne.tcp_port = item.tcp_port
    state.bgpAdvacne.external_distance = item.external_distance
    state.bgpAdvacne.internal_distance = item.internal_distance
    state.bgpAdvacne.distance_local = item.distance_local
    state.bgpAdvacne.redist_static_enable = item.redist_static_enable
    state.bgpAdvacne.redist_rip_enable = item.redist_rip_enable
    state.bgpAdvacne.redist_ospf_enable = item.redist_ospf_enable
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp network
  clearBgpNetwork (state) {
    state.bgpNetwork.id = 0
    state.bgpNetwork.network_addr = null
    state.bgpNetwork.network_mask = 0
  },
  setBgpNetwork (state, item) {
    state.bgpNetwork.id = item.id
    state.bgpNetwork.network_addr = item.network_addr
    state.bgpNetwork.network_mask = item.network_mask
  },
  resetBgpNetworkList (state) {
    state.bgpNetworkList = []
  },
  setBgpNetworkList (state, data) {
    state.bgpNetworkList = data
  },
  addBgpNetworkList (state, item) {
    if (item !== undefined) {
      state.bgpNetworkList.push(item)
    }
  },
  editBgpNetworkList (state, item) {
    const findRslt = _.find(state.bgpNetworkList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.bgpNetworkList.splice(_.findIndex(state.bgpNetworkList, state.selectedItem), 1, item)
    }
  },
  delBgpNetworkList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.bgpNetworkList.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp neighbor
  clearBgpNeighbor (state) {
    state.bgpNeighbor.id = 0
    state.bgpNeighbor.router_addr = null
    state.bgpNeighbor.remote_as = 1
    state.bgpNeighbor.port = 179
    state.bgpNeighbor.default_orig_enable = 0
  },
  setBgpNeighbor (state, item) {
    state.bgpNeighbor.id = item.id
    state.bgpNeighbor.router_addr = item.router_addr
    state.bgpNeighbor.remote_as = item.remote_as
    state.bgpNeighbor.port = item.port
    state.bgpNeighbor.default_orig_enable = item.default_orig_enable
  },
  resetBgpNeighborList (state) {
    state.bgpNeighborList = []
  },
  setBgpNeighborList (state, data) {
    state.bgpNeighborList = data
  },
  addBgpNeighborList (state, item) {
    if (item !== undefined) {
      state.bgpNeighborList.push(item)
    }
  },
  editBgpNeighborList (state, item) {
    const findRslt = _.find(state.bgpNeighborList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.bgpNeighborList.splice(_.findIndex(state.bgpNeighborList, state.selectedItem), 1, item)
    }
  },
  delBgpNeighborList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.bgpNeighborList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp config
  async getBgpConfig ({commit, state}, loadingOpt) {
    commit('resetBgpConfig')
    const apiUrl = state.apiUrlPath['bgpConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpConfig', result)
      return true
    } else {
      return false
    }
  },
  async editBgpConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['bgpConfig']
    const rslt = await this.$axios.$put(apiUrl, state.bgpConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setBgpConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp status
  async getBgpStatus ({commit, state}) {
    commit('resetBgpStatus')
    const apiUrl = state.apiUrlPath['bgpStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpStatus', result)
      return true
    } else {
      return false
    }
  },
  async getBgpNeighborStatus ({commit, state}) {
    commit('resetBgpNeighborStatus')
    const apiUrl = state.apiUrlPath['bgpNeighborStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpNeighborStatus', result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp advance
  async getBgpAdvance ({commit, state}) {
    commit('resetBgpAdvance')
    const apiUrl = state.apiUrlPath['bgpAdvance']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpAdvance', result)
      return true
    } else {
      return false
    }
  },
  async editBgpAdvance ({commit, state}) {
    const apiUrl = state.apiUrlPath['bgpAdvance']
    const {code, result} = await this.$axios.$put(apiUrl, state.bgpAdvacne)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpAdvance', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp network list
  async getBgpNetworkList ({commit, state}, loadingOpt) {
    commit('resetBgpNetworkList')
    const apiUrl = state.apiUrlPath['bgpNetworks']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpNetworkList', result)
      return true
    } else {
      return false
    }
  },
  async addBgpNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['bgpNetworks']
    const addParam = {
      network_addr: state.bgpNetwork.network_addr,
      network_mask: Number(state.bgpNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addBgpNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editBgpNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['bgpNetworks']
    const putParam = {
      network_addr: state.bgpNetwork.network_addr,
      network_mask: Number(state.bgpNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.bgpNetwork.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editBgpNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delBgpNetworkList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['bgpNetworks']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delBgpNetworkList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp router(neighbor) list
  async getBgpRouterList ({commit, state}, loadingOpt) {
    commit('resetBgpNeighborList')
    const apiUrl = state.apiUrlPath['bgpNeighbors']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setBgpNeighborList', result)
      return true
    } else {
      return false
    }
  },
  async addBgpRouterList ({commit, state}) {
    const apiUrl = state.apiUrlPath['bgpNeighbors']
    const addParam = {
      router_addr: state.bgpNeighbor.router_addr,
      remote_as: state.bgpNeighbor.remote_as,
      port: state.bgpNeighbor.port,
      default_orig_enable: state.bgpNeighbor.default_orig_enable
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addBgpNeighborList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editBgpRouterList ({commit, state}) {
    const apiUrl = state.apiUrlPath['bgpNeighbors']
    const putParam = {
      router_addr: state.bgpNeighbor.router_addr,
      remote_as: state.bgpNeighbor.remote_as,
      port: state.bgpNeighbor.port,
      default_orig_enable: state.bgpNeighbor.default_orig_enable
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.bgpNeighbor.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editBgpNeighborList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delBgpRouterList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['bgpNeighbors']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delBgpNeighborList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Bgp apply & cancel
  async setBgpApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['bgpApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setBgpCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['bgpCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Bgp apply & cancel
}

export const getters = {
  // bgp Config
  compareBgpConfigData (state) {
    return compareObject(state.bgpConfig, state.bgpConfigClone)
  }
}

export const strict = false
